var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Sorts cancellation reason codes alphabetically by description, with "Other" always placed at the end
 * @param cancellationReasonCodes - Array of reason codes to sort
 * @returns Sorted array of reason codes by description (ascending), with "Other" option at the end
 */
export var getSortedCancelReasonOptions = function (cancellationReasonCodes) {
    if (!cancellationReasonCodes)
        return [];
    var reasons = __spreadArray([], cancellationReasonCodes, true).sort(function (optA, optB) {
        return optA.description.localeCompare(optB.description);
    });
    var otherIndex = reasons.findIndex(function (reason) { return reason.description === 'Other'; });
    if (otherIndex !== -1) {
        var other = reasons.splice(otherIndex, 1);
        reasons.push(other[0]);
    }
    return reasons;
};
